import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Booking from './components/Booking';
import FloatingBookButton from './components/FloatingBookButton';
import HerbTea from './components/HerbTea'; // Add this import
import Telemedicine from './components/Telemedicine';
import Store from './components/Store';
<FloatingBookButton />

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/herbtea" element={<HerbTea />} /> 
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/telemedicine" element={<Telemedicine />} />
          <Route path="/store" element={<Store />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;